<template>
  <v-layout>
    <v-container>
      <v-row>
        <v-col cols="6" sm="6" md="6" justify-center>
          <v-row align="center" justify="center">
            <v-img
              max-height="600"
              max-width="400"
              :src="require('@/assets/logo.png')"
            ></v-img>
          </v-row>

          <v-form ref="form" autocomplete="off">
            <v-text-field
              ref="username"
              v-model="username"
              :rules="requiredField"
              label
              placeholder="Username"
              required
            ></v-text-field>
            <v-text-field
              ref="password"
              v-model="password"
              :type="show2 ? 'text' : 'password'"
              :rules="[() => !!password || 'This field is required']"
              :append-icon="show2 ? 'mdi-eye' : 'mdi-eye-off'"
              label
              placeholder="Password"
              v-on:keyup="keyupSubmit"
              @click:append="show2 = !show2"
            ></v-text-field>
            <br />
            <v-checkbox
              v-model="eula_check"
              :rules="[() => !!eula_check || 'This field is required']"
              label="By using Alimera Sciences ePRO New Day Study App & Web Service, you agree to the EULA"
            >
            </v-checkbox>
            <p>
              <router-link to="/eula">End User License Agreement</router-link>
            </p>
            <v-btn block color="primary" @click="submit">Submit</v-btn>
            <v-card-text
              style="margin-top: 20px; text-align: center; padding: 0px"
            >
              Forgot Password? Click
              <router-link to="/forgotPassword">here</router-link>
              to reset it.
            </v-card-text>
            <v-card-text style="text-align: center; padding: 0px">
              Or
            </v-card-text>
            <v-card-text style="text-align: center; padding: 0px">
              Contact Support at
              <a href="mailto:newdayapp@infocusclinical.com"
                >newdayapp@infocusclinical.com</a
              >
              / 615-944-0582
            </v-card-text>
          </v-form>
        </v-col>
        <v-col cols="6" sm="6" md="6">
          <!-- <v-img
              max-height="900"
              max-width="600"
              :src="require('@/assets/person-min.png')"
            ></v-img> -->
          <v-img :src="require('@/assets/person-min.png')"></v-img>
        </v-col>
      </v-row>
    </v-container>
    <div class="text-center">
      <v-snackbar
        v-model="snackbar"
        :timeout="timeout"
        color="error"
        :top="y === 'top'"
      >
        {{ text }}
        <template v-slot:action="{ attrs }">
          <v-btn color="white" text v-bind="attrs" @click="snackbar = false"
            >Close</v-btn
          >
        </template>
      </v-snackbar>
    </div>
  </v-layout>
</template>

<script>
/* eslint-disable no-debugger */
export default {
  data: () => ({
    snackbar: false,
    text: "REQUEST COMPLETE",
    timeout: 4000,
    y: "top",
    username: "",
    password: "",
    eula_check: "",
    show2: false,
    requiredField: [
      (v) => !!v || "This field is required",
      (v) => v.length >= 3 || "Minimum length is 3 characters",
    ],
    failedLogins: 0,
  }),
  created() {},
  methods: {
    keyupSubmit(e) {
      if (e.keyCode === 13) {
        this.submit();
      }
    },
    submit() {
      //OID10001
      if (this.$refs.form.validate()) {
        console.log("submit");
        const baseURI = this.$store.getters.getBaseUrl + "login";
        this.$http
          .post(baseURI, {
            username: this.username,
            password: this.password,
          })
          .then((result) => {
            this.$store.commit("setLoggedUser", result.data);
            this.$store.commit("setToken", result.data.token);
            this.$store.commit("setViewedVideo", result.data.viewedVideo);

            if (result.data.viewedVideo == false) {
              this.$router.push({ path: "/" });
            }

            if (result.data.cp) {
              this.$store.commit("setNeedToChangePassword", true);
              this.$router.push({ path: "changeMyPassword" });
            } else {
              this.$store.commit("setNeedToChangePassword", false);
              this.$router.push("/");
            }
          })
          .catch((error) => {
            this.text =
              typeof error.response == "undefined"
                ? error
                : error.response.data;
            this.snackbar = true;
            console.log("error " + error);
            this.failedLogins = this.failedLogins + 1;

            if (this.failedLogins == 5) {
              this.text =
                "You account has been locked due to 5 failed attempts. Please contact support.";

              this.$http
                .post(
                  this.$store.getters.getBaseUrl +
                    "notifySuperAdminsOfAccountLock",
                  {
                    username: this.username,
                  }
                )
                .then(() => {});
            }
          });
      }
    },
    resetFields() {
      this.$refs.form.reset();
    },
  },
  mounted() {
    this.$store.commit("setMenuOptions", []);
  },
};
</script>

<style>
</style>
